import React from "react"

import {
  Card,
  Stack,
  Radio,
  Grid,
  Typography,
  FormLabel,
  Checkbox,
  CardActionArea,
  Box,
} from "@mui/material"

export interface RadioBoxProps {
  type: "radio" | "checkbox"
  title?: string
  subtitle?: string
  description?: string
  descriptionStyles?: object
  children?: React.ReactNode
  childrenProps?: {}
  disabled?: boolean
  selectProps?: {
    id?: string
    checked: boolean
    onChange?: (e?: any, value?: any) => void
    value?: string | number | {}
    name?: string
    inputProps?: {}
    onClick?: () => void
  }
  "data-testid"?: string
}

export const RadioBox = ({
  type = "radio",
  title,
  subtitle,
  description,
  descriptionStyles = {},
  disabled,
  children,
  childrenProps,
  selectProps,
  ...props
}: RadioBoxProps) => {
  return (
    <Card
      elevation={0}
      sx={(theme) => ({
        // minheight: 100,
        marginY: 1,
        border:
          selectProps?.checked && !disabled
            ? `1.5px solid ${theme.palette.primary.main}`
            : `1px solid ${theme.palette.grey["400"]}`,
      })}
    >
      <CardActionArea data-testid={props["data-testid"]}>
        <Box sx={{ padding: 2 }}>
          <FormLabel disabled={disabled}>
            <Grid container spacing={0.5} sx={{ maxHeight: "max-content" }}>
              <Grid item xs={10}>
                <Stack spacing={2}>
                  {title ? <Typography variant="h6">{title}</Typography> : null}
                  <Stack>
                    {subtitle ? (
                      <Typography variant="h6" sx={{ fontSize: "1.1rem" }}>
                        {subtitle}
                      </Typography>
                    ) : null}
                    {description ? (
                      <Typography
                        sx={{ fontSize: "1rem", ...descriptionStyles }}
                      >
                        {description}
                      </Typography>
                    ) : null}
                  </Stack>
                  {children ? (
                    <Stack sx={childrenProps}> {children} </Stack>
                  ) : null}
                </Stack>
              </Grid>
              <Grid
                item
                xs={2}
                sx={{
                  display: "flex",
                  alignItems: "start",
                  justifyContent: "end",
                }}
              >
                {type === "radio" ? (
                  <Radio
                    {...selectProps}
                    sx={{ padding: 0 }}
                    disabled={disabled}
                  />
                ) : (
                  <Checkbox
                    {...selectProps}
                    sx={{ padding: 0 }}
                    disabled={disabled}
                  />
                )}
              </Grid>
            </Grid>
          </FormLabel>
        </Box>
      </CardActionArea>
    </Card>
  )
}
